import withReducer from '../../store/withReducer'
import AppOrchard from './container'
import reducer from './module'

export default withReducer('appOrchard', {})(AppOrchard)
// export default AppOrchard



// WEBPACK FOOTER //
// ./src/legacy/pages/AppOrchard/index.jsx